/** Filipino for the registry, card desk, help and privacy screens. Keyed by the English text. */
export const FIL_REGISTRY: Record<string, string> = {
  "4Ps beneficiary": "Benepisyaryo ng 4Ps",
  "60 and over": "60 pataas",
  "A child of {name}": "Anak ni {name}",
  "A parent of {name}": "Magulang ni {name}",
  "Actions": "Aksyon",
  "Active": "Aktibo",
  "Add": "Idagdag",
  "Add or move a member here": "Magdagdag o maglipat ng miyembro dito",
  "Added": "Idinagdag",
  "Address": "Address",
  "Age": "Edad",
  "All": "Lahat",
  "All barangays": "Lahat ng barangay",
  "All sectors": "Lahat ng sektor",
  "Already registered as {n}.": "Nakarehistro na bilang {n}.",
  "Any age": "Kahit anong edad",
  "Any status": "Kahit anong status",
  "Approve": "Aprubahan",
  "Avoid 1234, 0000 or your birth year.": "Iwasan ang 1234, 0000 o taon ng kapanganakan.",
  "Barangay": "Barangay",
  "Birth": "Kapanganakan",
  "Birth date": "Petsa ng kapanganakan",
  "Birth place": "Lugar ng kapanganakan",
  "Block": "I-block",
  "Block card {n}": "I-block ang card {n}",
  "Block now": "I-block ngayon",
  "Blocked": "Naka-block",
  "By": "Ni",
  "Camera preview": "Silip ng camera",
  "Card": "Card",
  "Card active": "Aktibo ang card",
  "Card desk": "Card desk",
  "Card number": "Numero ng card",
  "Card number, name or CON number": "Numero ng card, pangalan o CON number",
  "Card {n} for {name}. The chip must already be encoded with the LGU keys.": "Card {n} para kay {name}. Dapat naka-encode na ang chip gamit ang mga key ng LGU.",
  "Cards": "Mga card",
  "Category": "Kategorya",
  "Change": "Palitan",
  "Change approvals": "Pag-apruba ng pagbabago",
  "Change status": "Palitan ang status",
  "Checking every row…": "Sinusuri ang bawat hanay…",
  "Checking the card…": "Sinusuri ang card…",
  "Checking the chip…": "Sinusuri ang chip…",
  "Chip": "Chip",
  "Chip linked": "Naka-link ang chip",
  "Chip not linked": "Hindi pa naka-link ang chip",
  "Choose .xlsx file": "Pumili ng .xlsx file",
  "Choose a 4-digit PIN": "Pumili ng 4-digit PIN",
  "Choose a different PIN": "Pumili ng ibang PIN",
  "Choose…": "Pumili…",
  "Civil status": "Civil status",
  "Clear": "Burahin",
  "Closing balance": "Huling balanse",
  "Code": "Code",
  "Compare the person in front of you with the profile photo.": "Ikumpara ang taong kaharap mo sa litrato sa profile.",
  "Compare the photos and details. Choose \"Same person\" to stop, or \"Different person\" with a reason.": "Ikumpara ang mga litrato at detalye. Piliin ang \"Parehong tao\" para huminto, o \"Ibang tao\" na may dahilan.",
  "Consent": "Pahintulot",
  "Constituent": "Constituent",
  "Constituent number": "Constituent number",
  "Constituent photo": "Litrato ng constituent",
  "Constituents": "Mga constituent",
  "Create a household with this person as head, or add them to an existing one from Households.": "Gumawa ng sambahayan na siya ang pinuno, o idagdag siya sa umiiral na sambahayan.",
  "Create with this head": "Gumawa na ito ang pinuno",
  "Credits, purchases and PIN changes are sent here by SMS.": "Dito ipinapadala sa SMS ang mga credit, bili at pagbabago ng PIN.",
  "Date": "Petsa",
  "Deceased": "Pumanaw",
  "Delete last digit": "Burahin ang huling numero",
  "Details": "Detalye",
  "Different person: register": "Ibang tao: irehistro",
  "Do not continue if the person does not match the photo.": "Huwag ituloy kung hindi tugma ang tao sa litrato.",
  "Document type": "Uri ng dokumento",
  "Documents": "Mga dokumento",
  "Duplicate check": "Pagsuri ng doble",
  "Earliest expiry {d}": "Pinakamaagang expiry {d}",
  "End link": "Tapusin ang link",
  "End this link?": "Tapusin ang link na ito?",
  "Face the camera, no hat or sunglasses, plain background.": "Humarap sa camera, walang sumbrero o shades, payak na background.",
  "Family": "Pamilya",
  "Family tree": "Family tree",
  "Farmer": "Magsasaka",
  "Female": "Babae",
  "Find a constituent by name, number, card number or ID number.": "Hanapin ang constituent ayon sa pangalan, numero, card o ID number.",
  "Find the person": "Hanapin ang tao",
  "First name": "Pangalan",
  "Fisherfolk": "Mangingisda",
  "For outreach registrations, e.g. \"Brgy San Isidro, 12 Oct\".": "Para sa outreach na rehistro, hal. \"Brgy San Isidro, 12 Okt\".",
  "For the pilot only. A test card is tapped with a button on screen.": "Para sa pilot lang. Ang test card ay tina-tap gamit ang button sa screen.",
  "From": "Mula",
  "Full name": "Buong pangalan",
  "Guides": "Mga gabay",
  "Guides for": "Gabay para sa",
  "Head": "Pinuno",
  "History": "Kasaysayan",
  "Hold the card on the back of this phone.": "Ilapat ang card sa likod ng teleponong ito.",
  "Household": "Sambahayan",
  "Household code or member name": "Code ng sambahayan o pangalan ng miyembro",
  "Household {code}": "Sambahayan {code}",
  "Households": "Mga sambahayan",
  "ID checked": "Nasuring ID",
  "ID number": "ID number",
  "ID numbers are encrypted. The same ID cannot be registered twice.": "Naka-encrypt ang mga ID number. Hindi maaaring irehistro nang dalawang beses ang parehong ID.",
  "ID photo taken": "Nakuhanan na ang ID",
  "ID type": "Uri ng ID",
  "Identity changes made at accredited stores. Contact, address and PIN changes apply at once and are not listed here.": "Mga pagbabago sa pagkakakilanlan na ginawa sa accredited na tindahan. Ang contact, address at PIN ay agad na naa-apply at wala rito.",
  "If the person is in another household, they are moved out of it.": "Kung nasa ibang sambahayan ang tao, ililipat siya palabas doon.",
  "Import from Excel": "Mag-import mula sa Excel",
  "Import {n} ready rows": "I-import ang {n} handang hanay",
  "In": "Pasok",
  "Indigenous people": "Katutubo",
  "Indigent": "Indigent",
  "Issue a card": "Mag-isyu ng card",
  "Issue card": "Mag-isyu ng card",
  "Issue replacement": "Mag-isyu ng kapalit",
  "Issue, print, link, release, block and replace NFC ID cards.": "Mag-isyu, mag-print, mag-link, mag-release, mag-block at magpalit ng NFC ID card.",
  "LGU staff": "Kawani ng LGU",
  "Last name": "Apelyido",
  "Leave blank to keep": "Iwanang blangko para hindi baguhin",
  "Leave blank to use the fee set by ordinance.": "Iwanang blangko para gamitin ang bayad ayon sa ordinansa.",
  "Link": "I-link",
  "Link a family member": "Mag-link ng kapamilya",
  "Link chip": "I-link ang chip",
  "Link the chip": "I-link ang chip",
  "Linked": "Naka-link",
  "Live-in": "Live-in",
  "Load a blank PVC card (CR80) in the card printer and print at 100% scale. Front and back print as two pages.": "Maglagay ng blangkong PVC card (CR80) sa printer at mag-print sa 100%. Dalawang pahina ang harap at likod.",
  "Load existing lists (senior citizens, PWD, barangay registries) without re-encoding.": "I-load ang mga umiiral na listahan nang hindi muling ine-encode.",
  "Locked until {t}": "Naka-lock hanggang {t}",
  "Locked: reset with a valid ID": "Naka-lock: i-reset gamit ang valid ID",
  "Make head": "Gawing pinuno",
  "Male": "Lalaki",
  "Manage household": "Pamahalaan ang sambahayan",
  "Married": "Kasal",
  "Matches": "Mga tugma",
  "Members": "Mga miyembro",
  "Merchants": "Mga merchant",
  "Middle name": "Gitnang pangalan",
  "Mobile": "Mobile",
  "Mobile number": "Mobile number",
  "Moved out": "Lumipat",
  "Moved out or deceased blocks the card at once and stops future credits.": "Kapag lumipat o pumanaw, agad na iba-block ang card at titigil ang mga credit.",
  "Moves": "Mga paglipat",
  "Name": "Pangalan",
  "Name in file": "Pangalan sa file",
  "Name or CON number": "Pangalan o CON number",
  "Name, CON number, card or ID number": "Pangalan, CON number, card o ID number",
  "Needs completion": "Kailangang kumpletuhin",
  "Never the only accepted ID.": "Hindi lang ito ang tinatanggap na ID.",
  "New": "Bago",
  "New 4-digit PIN": "Bagong 4-digit PIN",
  "New household": "Bagong sambahayan",
  "New household, this person as head": "Bagong sambahayan, siya ang pinuno",
  "New photo ready": "Handa na ang bagong litrato",
  "New registration": "Bagong rehistro",
  "New requests appear here and in your notifications.": "Lalabas dito at sa iyong abiso ang mga bagong kahilingan.",
  "Next": "Susunod",
  "No NFC? Type the card number in the search box instead.": "Walang NFC? I-type ang numero ng card sa search box.",
  "No active card": "Walang aktibong card",
  "No assistance balance right now.": "Walang balanse ng ayuda sa ngayon.",
  "No card": "Walang card",
  "No card issued yet.": "Wala pang na-isyung card.",
  "No cards here.": "Walang card dito.",
  "No changes recorded.": "Walang naitalang pagbabago.",
  "No children linked": "Walang naka-link na anak",
  "No documents yet.": "Wala pang dokumento.",
  "No guide matches. Try another word.": "Walang tugmang gabay. Subukan ang ibang salita.",
  "No households yet.": "Wala pang sambahayan.",
  "No match. The person must be registered first.": "Walang tugma. Kailangang nakarehistro muna ang tao.",
  "No mobile number": "Walang mobile number",
  "No movements in this period.": "Walang galaw sa panahong ito.",
  "No one matches these filters.": "Walang tumugma sa mga filter.",
  "No parents linked": "Walang naka-link na magulang",
  "No sector": "Walang sektor",
  "No signature.": "Walang pirma.",
  "Not in a household yet": "Wala pa sa sambahayan",
  "Not linked": "Hindi naka-link",
  "Note": "Tala",
  "Nothing waiting": "Walang naghihintay",
  "Official receipt number": "Numero ng opisyal na resibo",
  "On file": "Nakatala",
  "Open in card desk": "Buksan sa card desk",
  "Open profile": "Buksan ang profile",
  "Open signature on file": "Buksan ang nakatalang pirma",
  "Open that profile": "Buksan ang profile na iyon",
  "Open the template in Excel, fill one person per row, and save as .xlsx. Sectors are codes separated by commas (SENIOR, PWD, SOLO_PARENT, INDIGENT, 4PS, FARMER, FISHERFOLK, IP, YOUTH, PREGNANT, OTHER). Up to 5,000 rows per file.": "Buksan ang template sa Excel, isang tao bawat hanay, at i-save bilang .xlsx. Ang sektor ay mga code na pinaghihiwalay ng kuwit (SENIOR, PWD, SOLO_PARENT, INDIGENT, 4PS, FARMER, FISHERFOLK, IP, YOUTH, PREGNANT, OTHER). Hanggang 5,000 hanay bawat file.",
  "Open {name}": "Buksan si {name}",
  "Opening balance": "Panimulang balanse",
  "Optional but recommended.": "Opsyonal pero inirerekomenda.",
  "Other": "Iba pa",
  "Out": "Labas",
  "PIN": "PIN",
  "PIN locked": "Naka-lock ang PIN",
  "PIN set by the constituent.": "Ang constituent ang nagtakda ng PIN.",
  "PIN set. Turn the screen back to the staff.": "Naitakda ang PIN. Ibalik ang screen sa kawani.",
  "People living together, with a head. Programs can credit per household.": "Mga taong magkakasama sa bahay, may pinuno. Maaaring mag-credit ang programa bawat sambahayan.",
  "Person with disability": "Taong may kapansanan",
  "PhilSys": "PhilSys",
  "PhilSys number (PSN)": "PhilSys number (PSN)",
  "Photo of the ID shown": "Litrato ng ipinakitang ID",
  "Photo of {name}": "Litrato ni {name}",
  "Photo on file": "Nakatalang litrato",
  "Photograph the ID (optional)": "Kunan ng litrato ang ID (opsyonal)",
  "Pilot mode: test cards (without a chip) are allowed. Turn this off before real cards are released.": "Pilot mode: pinapayagan ang test card (walang chip). Patayin ito bago i-release ang totoong card.",
  "Possible duplicates": "Posibleng doble",
  "Possible duplicates (not imported)": "Posibleng doble (hindi na-import)",
  "Pregnant or nursing": "Buntis o nagpapasuso",
  "Previous": "Nakaraan",
  "Print": "I-print",
  "Print card": "I-print ang card",
  "Printed": "Na-print",
  "Privacy notice": "Paunawa sa privacy",
  "Problem": "Problema",
  "Profile sections": "Bahagi ng profile",
  "Progress": "Progreso",
  "Purok / sitio": "Purok / sitio",
  "Ready": "Handa",
  "Reason": "Dahilan",
  "Reason for the change": "Dahilan ng pagbabago",
  "Reason or reference": "Dahilan o reperensya",
  "Reason they are different people": "Dahilan kung bakit magkaibang tao",
  "Register": "Irehistro",
  "Register a constituent": "Magrehistro ng constituent",
  "Register the next person": "Irehistro ang susunod",
  "Registered": "Nakarehistro",
  "Registration event": "Event ng rehistro",
  "Registry": "Rehistro",
  "Reject": "Tanggihan",
  "Release": "I-release",
  "Release and activate": "I-release at i-activate",
  "Release the card": "I-release ang card",
  "Released": "Na-release",
  "Remove from household": "Alisin sa sambahayan",
  "Remove {name}?": "Alisin si {name}?",
  "Replace": "Palitan",
  "Replace card {n}": "Palitan ang card {n}",
  "Replace photo": "Palitan ang litrato",
  "Replaced": "Napalitan",
  "Replacement fee (₱)": "Bayad sa kapalit (₱)",
  "Required when rejecting.": "Kailangan kapag tinatanggihan.",
  "Reset the PIN (the constituent types the new one)": "I-reset ang PIN (ang constituent ang magta-type ng bago)",
  "Retake": "Kunan ulit",
  "Row": "Hanay",
  "Rows": "Mga hanay",
  "Rows with errors (not imported)": "Mga hanay na may mali (hindi na-import)",
  "Same person: do not register": "Parehong tao: huwag irehistro",
  "Save changes": "I-save ang pagbabago",
  "Save status": "I-save ang status",
  "Search help": "Maghanap sa tulong",
  "Search help, e.g. PIN, billing, lost card": "Maghanap, hal. PIN, billing, nawalang card",
  "Sector": "Sektor",
  "Sectors": "Mga sektor",
  "Senior citizen": "Senior citizen",
  "Separated": "Hiwalay",
  "Set {d}": "Itinakda {d}",
  "Sex": "Kasarian",
  "Signature captured.": "Nakuha ang pirma.",
  "Signature or thumbmark": "Pirma o thumbmark",
  "Signature or thumbmark on the release log": "Pirma o thumbmark sa release log",
  "Single": "Walang asawa",
  "Solo parent": "Solo parent",
  "Source": "Pinagmulan",
  "Spouse or partner of {name}": "Asawa o partner ni {name}",
  "Start again": "Magsimula ulit",
  "Statement": "Statement",
  "Status": "Status",
  "Step {n} of {total}: {name}": "Hakbang {n} ng {total}: {name}",
  "Step-by-step guides for every part of the system.": "Gabay hakbang-hakbang sa bawat bahagi ng sistema.",
  "Street / house no.": "Kalye / numero ng bahay",
  "Suffix": "Suffix",
  "Take photo": "Kumuha ng litrato",
  "Tap a card": "I-tap ang card",
  "Tap the new card on the back of this phone.": "I-tap ang bagong card sa likod ng teleponong ito.",
  "Template": "Template",
  "Test card": "Test card",
  "Test card (no chip)": "Test card (walang chip)",
  "The PINs do not match.": "Hindi magkatugma ang mga PIN.",
  "The card stops working at every store within seconds. The balance stays safe in the wallet.": "Titigil ang card sa lahat ng tindahan sa loob ng ilang segundo. Ligtas ang balanse sa wallet.",
  "The card works with the PIN the person chose at registration. Remind them never to share it.": "Gumagana ang card sa PIN na pinili sa rehistro. Paalalahanan na huwag itong ibahagi.",
  "The constituent read (or was read) the privacy notice version {v} and agrees to the processing of their data for LGU assistance.": "Nabasa ng constituent (o binasa sa kanya) ang paunawa sa privacy bersyon {v} at pumapayag sa pagproseso ng kanyang datos para sa ayuda ng LGU.",
  "The face matches the photo on file": "Tugma ang mukha sa nakatalang litrato",
  "The link stays on record as ended.": "Mananatiling nakatala ang link bilang tapos na.",
  "The new card is linked to the same wallet and balance. The old card is disabled for good.": "Naka-link ang bagong card sa parehong wallet at balanse. Permanenteng hindi na gagana ang luma.",
  "The other person is…": "Ang ibang tao ay…",
  "The person acknowledges receiving the card.": "Kinikilala ng tao na natanggap niya ang card.",
  "They choose and type their own 4-digit PIN. Staff must not look.": "Sila ang pipili at magta-type ng sariling 4-digit PIN. Hindi dapat tumingin ang kawani.",
  "This browser cannot read NFC cards. Use Chrome on an Android phone, or type the card number.": "Hindi makabasa ng NFC card ang browser na ito. Gamitin ang Chrome sa Android, o i-type ang numero ng card.",
  "This person may already be registered": "Maaaring nakarehistro na ang taong ito",
  "To": "Hanggang",
  "To print, link or release": "Ipi-print, ili-link o ire-release",
  "Turn the screen toward the constituent.": "Iharap ang screen sa constituent.",
  "Type": "Uri",
  "Type the same PIN again": "I-type ulit ang parehong PIN",
  "Under 18": "Wala pang 18",
  "Update details or PIN": "I-update ang detalye o PIN",
  "Upload photo or PDF": "Mag-upload ng litrato o PDF",
  "Use a photo file": "Gumamit ng litratong file",
  "Valid ID": "Valid ID",
  "Valid ID shown by the person": "Valid ID na ipinakita ng tao",
  "Valid ID type": "Uri ng valid ID",
  "Wallet": "Wallet",
  "When": "Kailan",
  "Widowed": "Biyudo/Biyuda",
  "With errors": "May mali",
  "Youth": "Kabataan",
  "at {m}": "sa {m}",
  "e.g. birth certificate, marriage contract, sworn declaration": "hal. birth certificate, marriage contract, sinumpaang salaysay",
  "e.g. death certificate number, new address": "hal. numero ng death certificate, bagong address",
  "e.g. different parents and address, checked IDs": "hal. ibang magulang at address, sinuri ang ID",
  "e.g. moved in with family": "hal. lumipat kasama ng pamilya",
  "ending {n}": "nagtatapos sa {n}",
  "face NOT confirmed": "HINDI kumpirmado ang mukha",
  "face matched": "tugma ang mukha",
  "former member": "dating miyembro",
  "{name} is registered as": "Nakarehistro si {name} bilang",
  "{n} change waiting for approval": "{n} pagbabagong naghihintay ng apruba",
  "{n} ended link(s) kept on record.": "{n} natapos na link ang nakatala.",
  "{n} found": "{n} ang nakita",
  "{n} of 4 digits entered": "{n} sa 4 na numero ang nailagay",
  "{n} people imported. They appear in the registry marked \"Needs completion\".": "{n} tao ang na-import. Makikita sila sa rehistro na may tandang \"Kailangang kumpletuhin\".",
  "{n} years old": "{n} taong gulang",
  "Photo": "Litrato",
  "Review": "Suriin",
  "This is not an LGU card, or it could not be read. Try again.": "Hindi ito LGU card, o hindi mabasa. Subukan ulit.",
  "The card could not be read. Hold it still on the back of the phone.": "Hindi mabasa ang card. Hawakan ito nang hindi gumagalaw sa likod ng telepono.",
  "Allow NFC for this site to tap cards.": "Payagan ang NFC para sa site na ito.",
  "NFC is not available on this device.": "Walang NFC sa device na ito.",
  "No camera available. Choose a photo file instead.": "Walang camera. Pumili na lang ng litratong file.",
  "Too dark: move to better light.": "Masyadong madilim: lumipat sa mas maliwanag.",
  "Too bright: avoid light behind or above the face.": "Masyadong maliwanag: iwasan ang ilaw sa likod o itaas ng mukha.",
  "The photo looks blurred or the face is not visible. Try again.": "Malabo ang litrato o hindi kita ang mukha. Subukan ulit.",
  "Parent": "Magulang",
  "This person": "Ang taong ito",
  "Spouse or partner": "Asawa o partner",
  "Child": "Anak",
  "Credit": "Credit",
  "Purchase": "Bili",
  "Voided sale": "Na-void na benta",
  "Refund": "Refund",
  "Expired": "Nag-expire",
  "Adjustment": "Adjustment",
  "Proof of residency": "Patunay ng paninirahan",
  "Certificate of indigency": "Certificate of indigency",
  "Medical abstract": "Medical abstract",
  "Prescription": "Reseta",
  "Senior citizen ID": "Senior citizen ID",
  "PWD ID": "PWD ID",
  "Solo parent ID": "Solo parent ID",
  "Birth certificate": "Birth certificate",
  "Marriage certificate": "Marriage certificate",
  "Death certificate": "Death certificate",
};
